import { gql } from '@apollo/client';

import { VIDEO_STREAM_CORE_FIELDS } from '../queries';

const BIDDING_EVENT_CORE_FIELDS = gql`
  fragment BiddingEventCoreFields on BiddingEvent {
    id
    type
    value
    saleAssetName
    bidderDescription
    createdAt
    action
    level
    displayValue
    backgroundColor
    foregroundColor
  }
`;

export const SALE_BIDDING_EVENTS = gql`
  ${BIDDING_EVENT_CORE_FIELDS}
  ${VIDEO_STREAM_CORE_FIELDS}
  query SaleBiddingEvents($id: ID!) {
    sale(id: $id) {
      id
      name
      biddingEvents {
        ...BiddingEventCoreFields
      }
      saleRecordings {
        id
        startAt
        endAt
        url
      }
      videoStreams {
        ...VideoStreamCoreFields
        video {
          id
          filename
          contentType
          url
        }
      }
    }
  }
`;
